import { createSlice, current } from '@reduxjs/toolkit'
import immutabilityUpdate from 'immutability-helper'

const boardProjectList = createSlice({
    name: 'boardProjectList',
    initialState: {
        list: [],//Связка доска-проект
        listUser: [],//Список доступных пользователей доски
        listTransfer: [],//Список доступных досок для перемещения
        list_loaded: [],
        list_loaded_user: [],
        list_loaded_transfer: []
    },
    reducers: {
        load(state, action) {
            const id_project = parseInt(action.payload.id_project);
            state.list = [...state.list.filter(a => a.ID_Project !== id_project), ...action.payload.list].sort((a, b) => a.ID_Project - b.ID_Project || a.Order - b.Order);//Сначала сортируем по проекту, а затем по Order. Иначе криво работает перемещение
            state.list_loaded = [...state.list_loaded.filter(a => a.id_project !== id_project), { id_project: id_project }];
        },
        loadUser(state, action) {
            const id_project = parseInt(action.payload.id_project);
            state.listUser = [...state.listUser.filter(a => a.ID_Project !== id_project), ...action.payload.list];
            state.list_loaded_user = [...state.list_loaded_user.filter(a => a.id_project !== id_project), { id_project: id_project }];
        },
        loadTransfer(state, action) {
            const id_project = parseInt(action.payload.id_project);
            state.listTransfer = [...state.listTransfer.filter(a => a.ID_Project !== id_project), ...action.payload.list];
            state.list_loaded_transfer = [...state.list_loaded_transfer.filter(a => a.id_project !== id_project), { id_project: id_project }];
        },

        //Изменит сортировку
        orderChange(state, action) {
            const dragIndex = action.payload.dragIndex;//Первоначальный индекс элемента
            const hoverIndex = action.payload.hoverIndex;//Индекс куда перемещен элемент
            const idProject = action.payload.idProject;//ИД проекта

            const list = current(state.list).filter(a => a.ID_Project === idProject)

            const list_new = immutabilityUpdate(list, {
                $splice: [
                    [dragIndex, 1],
                    [hoverIndex, 0, list[dragIndex]],
                ],
            })

            const list_new_order = list_new.map((item, index) => {
                return { ...item, Order: index };
            });

            state.list = [...state.list.filter(a => a.ID_Project !== idProject), ...list_new_order];
        }
    }
})

export const { load, orderChange, loadTransfer, loadUser } = boardProjectList.actions
export default boardProjectList.reducer